import { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Grid,
  Divider,
  Typography,
  Breadcrumbs,
  Link,
  Theme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { SxProps } from '@mui/system';

interface IBreadcrumb {
  title: string;
  href?: string;
  active?: boolean;
}

interface Props {
  name: string;
  breadcrumbs?: IBreadcrumb[];
  children?: React.ReactElement;
  sx?: SxProps<Theme>;
}

const useStyles = makeStyles(() => ({
  box: {
    background: '#FFFFFF',
    height: '80px',
  },
  container: {
    alignItems: 'center',
    height: '100%',
    padding: '16px',
  },
}));

export const Title = ({
  name,
  children,
  breadcrumbs,
  sx,
}: Props) => {
  const classes = useStyles();

  const breadcrumbsComponent = useMemo(() => {
    if (!breadcrumbs) return null;

    return (
      <Box marginLeft="1em">
        <Breadcrumbs>
          {breadcrumbs.map((bc, i) => {
            if (bc.href) {
              return (
                <Link
                  key={bc.href + i}
                  component={RouterLink}
                  to={bc.href}
                  underline="hover"
                  color={bc.active ? 'text.primary' : 'inherit'}
                >
                  {bc.title}
                </Link>
              );
            }

            return (
              <Typography
                key={bc.title + i}
                color={bc.active ? 'text.primary' : 'inherit'}
              >
                {bc.title}
              </Typography>
            );
          })}
        </Breadcrumbs>
      </Box>
    );
  }, [breadcrumbs]);

  return (
    <Box
      className={classes.box}
      sx={sx}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        className={classes.container}
      >
        <Grid container direction="row" alignItems="center" width="auto">
          <Typography
            gutterBottom
            color="textPrimary"
            variant="h5"
            marginBottom={0}
          >
            {name}
          </Typography>
          {breadcrumbsComponent}
        </Grid>
        {children}
      </Grid>
      <Divider />
    </Box>
  );
};
